import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const PrivacyModal = ({ visible, onHide, onApprove }) => {

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header="Gizlilik Sözleşmesi ve Kullanım Koşulları"
            style={{ width: '95vw', maxWidth: '800px', height: '95vh' }}
            className="privacy-modal"
            modal
            closable={true}
            resizable={false}
        >
            <div
                className="privacy-content"
                style={{
                    height: 'calc(95vh - 200px)',
                    maxHeight: 'calc(95vh - 200px)',
                    overflowY: 'auto',
                    padding: '1rem 0',
                    marginBottom: '1rem'
                }}
            >
                <div className="prose prose-sm">
                    {/* İçerik aynı kalıyor - sadece son div'e mb-6 ekleniyor */}
                    <h2 className="font-bold text-lg mb-4">GİZLİLİK SÖZLEŞMESİ VE KULLANIM KOŞULLARI</h2>

                    <h3 className="font-bold text-md mb-3">1. GİRİŞ</h3>
                    <p className="mb-4">
                        Bu Gizlilik Sözleşmesi ("Sözleşme"), PayPlus ("Şirket", "biz", "bizim") tarafından sunulan
                        hizmetlerin kullanımına ilişkin gizlilik politikalarını ve kullanım koşullarını açıklamaktadır.
                        Bu sözleşme, hizmetlerimizi kullanarak kabul etmiş olduğunuz şartları içermektedir.
                    </p>

                    <h3 className="font-bold text-md mb-3">2. BİLGİ TOPLAMA VE KULLANIM</h3>
                    <p className="mb-3">Aşağıdaki bilgi türlerini toplayabilir ve kullanabiliriz:</p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li><strong>Kişisel Bilgiler:</strong> Ad, soyad, e-posta adresi, telefon numarası, kimlik bilgileri</li>
                        <li><strong>Finansal Bilgiler:</strong> Banka hesap bilgileri, ödeme geçmişi, işlem kayıtları</li>
                        <li><strong>Teknik Bilgiler:</strong> IP adresi, tarayıcı bilgileri, cihaz bilgileri, çerezler</li>
                        <li><strong>Kullanım Bilgileri:</strong> Platform kullanım alışkanlıkları, tercihler, etkileşimler</li>
                        <li><strong>İletişim Bilgileri:</strong> Müşteri hizmetleri ile yapılan görüşmeler, e-posta trafiği</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">3. BİLGİ GÜVENLİĞİ</h3>
                    <p className="mb-4">
                        Kişisel bilgilerinizin güvenliğini sağlamak için endüstri standardı güvenlik önlemleri kullanıyoruz:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>SSL/TLS şifreleme teknolojisi</li>
                        <li>Güvenli sunucu altyapısı</li>
                        <li>Düzenli güvenlik denetimleri</li>
                        <li>Çalışan eğitimleri ve erişim kontrolü</li>
                        <li>Veri yedekleme ve kurtarma sistemleri</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">4. ÇEREZ POLİTİKASI</h3>
                    <p className="mb-4">
                        Web sitemiz ve mobil uygulamamız, kullanıcı deneyimini iyileştirmek, hizmetlerimizi kişiselleştirmek
                        ve istatistiksel analizler yapmak için çerezler kullanır. Çerez türleri:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li><strong>Zorunlu Çerezler:</strong> Temel işlevsellik için gerekli</li>
                        <li><strong>Performans Çerezleri:</strong> Site performansını ölçmek için</li>
                        <li><strong>İşlevsellik Çerezleri:</strong> Tercihlerinizi hatırlamak için</li>
                        <li><strong>Hedefleme Çerezleri:</strong> Kişiselleştirilmiş içerik sunmak için</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">5. ÜÇÜNCÜ TARAF HİZMETLER</h3>
                    <p className="mb-4">
                        Hizmetlerimizin sunumu sırasında aşağıdaki üçüncü taraf hizmet sağlayıcıları ile çalışabiliriz:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Ödeme işlemcileri ve bankalar</li>
                        <li>Kimlik doğrulama hizmeti sağlayıcıları</li>
                        <li>Bulut hizmet sağlayıcıları</li>
                        <li>Analitik ve pazarlama platformları</li>
                        <li>Müşteri destek sistemleri</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">6. KULLANICI SORUMLULUKLARI</h3>
                    <p className="mb-3">Hizmetlerimizi kullanırken aşağıdaki kurallara uymanız gerekmektedir:</p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Doğru ve güncel bilgi sağlama</li>
                        <li>Hesap güvenliğini koruma</li>
                        <li>Şifre ve erişim bilgilerini gizli tutma</li>
                        <li>Yasalara aykırı işlemler yapmama</li>
                        <li>Sistem güvenliğini tehlikeye atmama</li>
                        <li>Fikri mülkiyet haklarına saygı gösterme</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">7. VERİ SAKLAMA VE SİLME</h3>
                    <p className="mb-4">
                        Kişisel verileriniz, hizmet sunumu için gerekli olan süre boyunca ve yasal yükümlülüklerimiz
                        çerçevesinde saklanır. Talep etmeniz halinde, yasal saklama yükümlülükleri dışında kalan
                        verilerinizi silebiliriz.
                    </p>

                    <h3 className="font-bold text-md mb-3">8. DEĞİŞİKLİKLER</h3>
                    <p className="mb-4">
                        Bu gizlilik sözleşmesi, yasal gereksinimler veya hizmet değişiklikleri nedeniyle güncellenebilir.
                        Önemli değişiklikler için size bildirimde bulunacağız.
                    </p>

                    <h3 className="font-bold text-md mb-3">9. İLETİŞİM</h3>
                    <p className="mb-4">
                        Gizlilik politikamız hakkında sorularınız için bize aşağıdaki kanallardan ulaşabilirsiniz:
                    </p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>E-posta: info@payplus.com.tr</li>
                        <li>Telefon: +90 (532) 599 98 67</li>
                        {/* <li>Adres: PayPlus Genel Müdürlük</li> */}
                    </ul>

                    <div className="bg-orange-50 p-4 rounded-lg mt-6">
                        <p className="text-sm text-orange-800">
                            <strong>Önemli:</strong> Bu sözleşmeyi kabul ederek, yukarıda belirtilen tüm şartları
                            okuduğunuzu, anladığınızı ve kabul ettiğinizi beyan etmiş olursunuz. Bu sözleşme,
                            Türkiye Cumhuriyeti yasalarına tabidir.
                        </p>
                    </div>
                </div>
            </div>

            <div
                className="flex justify-end gap-3 mt-4 pt-4 border-t bg-white sticky bottom-0"
                style={{
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: 'white',
                    borderTop: '1px solid #e5e7eb',
                    paddingTop: '1rem',
                    marginTop: '1rem'
                }}
            >
                <Button
                    label="İptal"
                    className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-sm"
                    onClick={onHide}
                />
                <Button
                    label="Okudum ve Kabul Ediyorum"
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm"
                    onClick={() => {
                        onApprove();
                        onHide();
                    }}
                />
            </div>
        </Dialog>
    );
};

export default PrivacyModal;